<section class="buttons">
  <button *ngIf="!isAuctionList" nz-button nzSize="small" (click)="setAsAuctionList.emit()">
    <i nz-icon nzType="check"></i>
  </button>

  <button nz-button nzSize="small" (click)="openPreview.emit()">
    <i nz-icon nzType="zoom-in"></i>
  </button>

  <button nz-button nzSize="small" nzDanger (click)="remove.emit()">
    <i nz-icon nzType="delete"></i>
  </button>
</section>

<section *ngIf="isAuctionList" class="auction-list-mark">
  {{ 'AUCTION_LIST' | translate }}
</section>
